import React from 'react'
import Spinner from '../../../../components/Spinner/Spinner';
import Backdrop from '../../../../components/Backdrop/Backdrop';
import '../Shared/style.css'

const ReportViewer = ({ url, waitMsg = '' }) => {
  // we wrap in a div to handle overflowing issues (scrollbar showing up)
  return !url ? (
    <>
      <h1 className='text-center mt-3'>{waitMsg}</h1>
      <Backdrop>
        <Spinner />
      </Backdrop>
    </>
  ) : <div id='reportViewer'><iframe style={{ width: "100%", height: "100%" }} src={`${url}#navpanes=0`} /></div>
}

export default ReportViewer